

/**
 * Return the SBM global object. This information is expected to be embedded in
 * the page on load by the WP back-end.
 */
var SBM = null;
if (window && window.SBM) {
  SBM = window.SBM;
} else {
  SBM = {};
}


export default SBM;

